import { configureStore, combineReducers } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import { persistReducer, persistStore } from "redux-persist";
import { encryptTransform } from 'redux-persist-transform-encrypt';
import storage from "./storage";
const encryptor = encryptTransform({
      secretKey: 'my-super-secret-key', // This should be unique per user
      onError: function (error) {
        console.error('Encryption error:', error);
      },
    });
const authPersistConfig = {
  key: "auth",
  storage,
  // whitelist: ["token", "role"],
  transforms: [encryptor],
};

const rootReducer = combineReducers({
  auth: persistReducer(authPersistConfig, authReducer),
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
